import { render, staticRenderFns } from "./WorkerModal.vue?vue&type=template&id=d3456672"
import script from "./WorkerModal.vue?vue&type=script&lang=js"
export * from "./WorkerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports